export var EFootballSchoolSelection;
(function (EFootballSchoolSelection) {
    EFootballSchoolSelection["U1"] = "U1";
    EFootballSchoolSelection["U7"] = "U7";
    EFootballSchoolSelection["U8"] = "U8";
    EFootballSchoolSelection["U9"] = "U9";
    EFootballSchoolSelection["U10"] = "U10";
    EFootballSchoolSelection["U11"] = "U11";
    EFootballSchoolSelection["U12"] = "U12";
    EFootballSchoolSelection["U13"] = "U13";
    EFootballSchoolSelection["U14"] = "U14";
    EFootballSchoolSelection["U15"] = "U15";
    EFootballSchoolSelection["U17"] = "U17";
    EFootballSchoolSelection["U19"] = "U19";
})(EFootballSchoolSelection || (EFootballSchoolSelection = {}));
